import { addItemToCollection } from "directus/src/operations";

export async function createEntity({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "name",
                "status",
                "organisation",
            ],
        };
        const data = await addItemToCollection("legal_entities", item, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}